var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { cloneDeep, omit } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { filter } from 'rxjs/operators';
import styled from 'styled-components';
import { clickButtonObj, delay, showPointerOnButton } from '../../../helpers/dom-utils';
import { KeyboardControlKeys } from '../../../helpers/keyboard';
import { bfs, isEmpty } from '../../../helpers/utils';
import { setActiveVABArray_AC } from '../../../store/s80_touchpanel.actions';
import BottomLeft from '../../assets/background-images/touch-panel-bl.png';
import BottomRight from '../../assets/background-images/touch-panel-br.png';
import TopLeft from '../../assets/background-images/touch-panel-tl.png';
import TopRight from '../../assets/background-images/touch-panel-tr.png';
import TouchPanelButton from '../TouchPanelButton';
import TPGeneralInformationArea from './GeneralInformationArea';
var TutorialArea = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 104px;\n  width: 100%;\n  margin-top: 10px;\n  border: solid 1px white;\n  color: white;\n"], ["\n  height: 104px;\n  width: 100%;\n  margin-top: 10px;\n  border: solid 1px white;\n  color: white;\n"])));
var TutorialContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: white;\n  margin-top: 10px;\n  margin-left: 10px;\n"], ["\n  color: white;\n  margin-top: 10px;\n  margin-left: 10px;\n"])));
var Container = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"])));
var FreeSpace = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 77px;\n  height: 100%;\n  display: grid;\n  grid-template-rows: 50px auto 50px 40px;\n  padding-top: 10px;\n"], ["\n  width: 77px;\n  height: 100%;\n  display: grid;\n  grid-template-rows: 50px auto 50px 40px;\n  padding-top: 10px;\n"])));
var FAB = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  height: 79px;\n  width: 100%;\n  margin-bottom: 10px;\n  display: grid;\n  grid-template-columns: repeat(10, 104px [col-start]);\n"], ["\n  height: 79px;\n  width: 100%;\n  margin-bottom: 10px;\n  display: grid;\n  grid-template-columns: repeat(10, 104px [col-start]);\n"])));
var VABArea = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  flex-grow: 1;\n  display: grid;\n  grid-template-columns: ", ";\n"], ["\n  flex-grow: 1;\n  display: grid;\n  grid-template-columns: ",
    ";\n"])), function (props) {
    return props.rowSize === 8 ? '104px auto 104px' : '92px auto 92px';
});
var VAB = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  flex-grow: 1;\n  display: grid;\n  grid-template-columns: ", ";\n  margin-top: 10px;\n"], ["\n  flex-grow: 1;\n  display: grid;\n  grid-template-columns: ",
    ";\n  margin-top: 10px;\n"])), function (props) {
    return "repeat(" + props.rowSize + ", " + (props.rowSize === 8 ? '104px' : '104px') + "  [col-start]);";
});
var BackgroundImg = styled.img(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: 80px;\n"], ["\n  width: 80px;\n"])));
var ref = function (ele, s80jsonDef) {
    if (ele && ele['$ref']) {
        var refId = ele['$ref'].slice(2);
        var paths = refId.split('/');
        var result_1 = s80jsonDef;
        paths.forEach(function (path) {
            result_1 = result_1[path];
        });
        return ref(result_1, s80jsonDef);
    }
    if (Array.isArray(ele)) {
        return ele.map(function (resEle) { return ref(resEle, s80jsonDef); });
    }
    return ele;
};
var getDefinition = function (refNode, s80jsonDef) {
    if (!refNode || !refNode['$ref']) {
        return;
    }
    var resultantRef = ref(refNode, s80jsonDef);
    if (resultantRef && resultantRef['$ref']) {
        return getDefinition(resultantRef, s80jsonDef);
    }
    if (Array.isArray(resultantRef)) {
        var length_1 = resultantRef.reduce(function (prev, curr) { return prev + curr.length; }, 0);
        var buttonRowSize = resultantRef ? resultantRef[0].length : 8;
        if (length_1 < buttonRowSize * 4) {
            var fill = Array(buttonRowSize * 4 - length_1).fill({});
            return resultantRef.concat([fill]);
        }
    }
    return resultantRef;
};
var fillEmptyArray = function (resultantArray) {
    var length = resultantArray.reduce(function (prev, curr) { return prev + curr.length; }, 0);
    var buttonRowSize = resultantArray ? resultantArray[0].length : 8;
    if (length < buttonRowSize * 4) {
        var fill = Array(buttonRowSize * 4 - length).fill({});
        return resultantArray.concat([fill]);
    }
    return resultantArray;
};
var rootNode = {
    type: 'root',
    vab: '#/MAIN ARRAY',
    parent: null,
    children: [],
};
var buildTree = function (jsonDef, dynamicData, node, depth) {
    if (node === void 0) { node = rootNode; }
    if (depth === void 0) { depth = 0; }
    var children = [];
    if (node.type === 'root') {
        var fabArray = jsonDef.fab_area;
        fabArray.forEach(function (fabButton) {
            if (fabButton.onClick) {
                if (fabButton.onClick.key) {
                    fabButton.onClick =
                        fabButton.onClick.alternatives[dynamicData[fabButton.onClick.key]];
                    children.push(getChildObj(fabButton, jsonDef, node));
                }
                else if (fabButton.onClick) {
                    children.push(getChildObj(fabButton, jsonDef, node));
                }
            }
        });
        return children.map(function (child) {
            return buildTree(jsonDef, dynamicData, child, depth + 1);
        });
    }
    if (node.type === 'child') {
        return __assign(__assign({}, node), { children: node.children.map(function (n) {
                if (!n.onClick) {
                    return n;
                }
                if (n.onClick.key) {
                    n.onClick = n.onClick.alternatives[dynamicData[n.onClick.key]];
                }
                return buildTree(jsonDef, dynamicData, getChildObj(n, jsonDef, node), depth + 1);
            }) });
    }
    return node;
};
var getChildObj = function (button, jsonDef, node) {
    var refVal = ref(button.onClick, jsonDef);
    return {
        type: 'child',
        id: button.id,
        children: refVal.flat().filter(function (val) { return !isEmpty(val); }),
        vab: refVal,
        parent: node.vab,
        parentId: node.id,
    };
};
export default function TouchPanel(props) {
    var _this = this;
    var s80json = props.s80json, onClick = props.onClick, actionService = props.actionService, dispatch = props.dispatch, content = props.content, onToggleButtonClick = props.onToggleButtonClick, onSpecialNavigationButton = props.onSpecialNavigationButton, _a = props.onKeyboardAction, onKeyboardAction = _a === void 0 ? function () { } : _a;
    var fabButtons = s80json.fab_area;
    var _b = useState(s80json['MAIN ARRAY']), mainArray = _b[0], setMainArray = _b[1];
    var _c = useState(''), lastNavigationClick = _c[0], setLastNavigationClick = _c[1];
    var _d = useState(false), capsLockOn = _d[0], setCapsLockOn = _d[1];
    var _e = useState({}), treeObj = _e[0], setTreeObj = _e[1];
    var ref = useRef(null);
    var tutorialAreaText = content.tutorialAreaText, activeRole = content.activeRole;
    var _f = useState({
        ACTIVE_ROLE: 'TACT1',
    }), dynamicProps = _f[0], setDynamicProps = _f[1];
    var _g = useState(), bClickAction = _g[0], setBClickAction = _g[1];
    useEffect(function () {
        console.log('touch panel spider', content.activeRole);
        setDynamicProps(function (dp) { return (__assign(__assign({}, dp), { ACTIVE_ROLE: (activeRole !== 'NONE' ? activeRole : 'TACT1').toUpperCase() })); });
    }, [content]);
    useEffect(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var payload, buttonId, getButton, buttonObj, buttonPath, i, path, bObj, button;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!bClickAction) return [3, 13];
                        payload = bClickAction.payload;
                        buttonId = payload.actionPayload.TouchPanelButtonClickedId;
                        getButton = function (id) {
                            return ref.current.querySelector("#" + id);
                        };
                        if (!(buttonId && ref && ref.current)) return [3, 11];
                        buttonObj = getButton(buttonId);
                        if (!buttonObj) return [3, 2];
                        return [4, showPointerOnButton(buttonObj, dispatch)];
                    case 1:
                        _a.sent();
                        clickButtonObj(buttonObj);
                        return [3, 10];
                    case 2:
                        buttonPath = bfs(treeObj, buttonId);
                        if (!buttonPath) {
                            console.log('touch panel spider', treeObj, buttonId);
                            alert("Can't find button: " + buttonId + " for current role");
                            return [2];
                        }
                        i = 0;
                        _a.label = 3;
                    case 3:
                        if (!(i < buttonPath.length)) return [3, 8];
                        path = buttonPath[i];
                        bObj = getButton(path);
                        return [4, showPointerOnButton(bObj, dispatch)];
                    case 4:
                        _a.sent();
                        return [4, clickButtonObj(bObj)];
                    case 5:
                        _a.sent();
                        return [4, delay(1000)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        i++;
                        return [3, 3];
                    case 8:
                        button = getButton(buttonId);
                        if (!button) return [3, 10];
                        return [4, showPointerOnButton(button, dispatch)];
                    case 9:
                        _a.sent();
                        clickButtonObj(button);
                        _a.label = 10;
                    case 10: return [3, 12];
                    case 11:
                        console.log('Cant click on touchpanel because buttonId:', buttonId, ' ref:', ref);
                        alert("Invalid Operation, something is wrong with the lesson definition, no buttonId provided for TouchPanelButtonOperation");
                        _a.label = 12;
                    case 12:
                        console.log(' I got action', ref, bClickAction);
                        _a.label = 13;
                    case 13: return [2];
                }
            });
        }); })();
    }, [bClickAction]);
    useEffect(function () {
        if (actionService) {
            var subscription_1 = actionService
                .getActions()
                .pipe(filter(function (action) { return action.type === 'SystemShowTouchPanelVabArray'; }))
                .subscribe(function (action) {
                var payload = action.payload;
                var vabObj = payload.actionPayload.vabArray;
                var value = vabObj && vabObj.value;
                var nextArray = value != null ? s80json[value] : undefined;
                if (!nextArray) {
                    console.warn("SystemShowTouchPanelVabArray: no vab array found for \"" + value + "\" in touch panel definition \u2014 ignoring");
                    return;
                }
                setMainArray(nextArray);
            });
            return function () {
                subscription_1.unsubscribe();
            };
        }
        return function () { };
    }, []);
    useEffect(function () {
        if (actionService && content.mode === 'demo') {
            var subscription_2 = actionService
                .getActions()
                .pipe(filter(function (action) { return action.type === 'TouchPanelButtonOperation'; }))
                .subscribe(function (action) { return setBClickAction(action); });
            return function () {
                subscription_2.unsubscribe();
            };
        }
        else {
            return function () {
                console.log('S80-TouchPanel-No actions subscribed');
            };
        }
    }, []);
    useEffect(function () {
        var touchPanelTree = {
            type: 'root',
            vab: s80json['MAIN ARRAY'],
            parent: null,
            children: buildTree(cloneDeep(s80json), dynamicProps, __assign(__assign({}, rootNode), { vab: s80json['MAIN ARRAY'] })),
        };
        setTreeObj(touchPanelTree);
        console.log('buildTree', touchPanelTree, s80json['MAIN ARRAY']);
        console.log('buildTree find node: j', bfs(touchPanelTree, 'j'));
    }, [dynamicProps]);
    var updateVABArray = function (value) {
        dispatch(setActiveVABArray_AC(value));
    };
    var onButtonClick = function (id, clickConfig, actionConfig, actionPayload) {
        if (actionPayload === void 0) { actionPayload = {}; }
        console.log('onButtonClick', clickConfig, s80json);
        if (actionConfig) {
            if (actionConfig === 'levelUp') {
                if (lastNavigationClick !== '') {
                    var nodePath = bfs(treeObj, lastNavigationClick);
                    var tree_1 = treeObj;
                    if (nodePath) {
                        nodePath.forEach(function (pathEle) {
                            tree_1 = tree_1.children.find(function (node) { return node.id === pathEle; });
                            console.log('first level up', tree_1);
                        });
                        if (tree_1.vab) {
                            var navHistory = (nodePath.slice(-1) || [])[0];
                            updateVABArray(lastNavigationClick);
                            setLastNavigationClick(navHistory);
                            setMainArray(fillEmptyArray(tree_1.vab));
                        }
                    }
                    console.log(nodePath);
                }
                return;
            }
            if (actionConfig === 'resetVAB') {
                updateVABArray('#/MAIN ARRAY');
                setLastNavigationClick('');
                setMainArray(treeObj.vab);
            }
            if (actionConfig === 'specialNavigationButton' && clickConfig) {
                onSpecialNavigationButton && onSpecialNavigationButton({ id: id });
            }
            if (actionConfig === 'illuminationControl') {
                dispatch({
                    type: 'UPDATE_TSD_ILLUMINATION',
                    payload: actionPayload,
                });
                onClick && onClick({ id: id });
                return;
            }
            if (actionConfig === 'blinkingControl') {
                dispatch({
                    type: 'UPDATE_TSD_BLINKING',
                    payload: actionPayload,
                });
                onClick && onClick({ id: id });
                return;
            }
            if (actionConfig === 'keyboard-item') {
                if (id === KeyboardControlKeys.CAPSLOCK) {
                    setCapsLockOn(function (isOn) { return !isOn; });
                    return;
                }
                onKeyboardAction &&
                    onKeyboardAction({
                        key: capsLockOn ? id.toUpperCase() : id,
                    });
                return;
            }
        }
        if (!clickConfig) {
            onClick && onClick({ id: id });
            return;
        }
        if (clickConfig.key) {
            var ref_1 = clickConfig.alternatives[dynamicProps[clickConfig.key]];
            var def = getDefinition(ref_1, s80json);
            console.log('touchPanel Def key', def, ref_1);
            if (!ref_1 || !def) {
                console.warn("TouchPanel: no vab array for role \"" + dynamicProps[clickConfig.key] + "\" (" + clickConfig.key + ") \u2014 ignoring navigation");
                return;
            }
            setLastNavigationClick(id);
            setMainArray(def);
            updateVABArray(ref_1['$ref']);
        }
        else {
            var def = getDefinition(clickConfig, s80json);
            console.log('touchPanel Def', def, clickConfig);
            if (!def) {
                console.warn("TouchPanel: no vab array for navigation target \"" + clickConfig['$ref'] + "\" \u2014 ignoring navigation");
                return;
            }
            setLastNavigationClick(id);
            setMainArray(def);
            updateVABArray(clickConfig['$ref']);
        }
    };
    var buttonRowSize = mainArray && mainArray[0] ? mainArray[0].length : 8;
    var buttonHeight = mainArray && mainArray.length === 7 ? 45 : 84;
    return (React.createElement(Container, { ref: ref },
        React.createElement(TPGeneralInformationArea, { content: content }),
        React.createElement(TutorialArea, { "data-area": "tutorial-area" },
            React.createElement(TutorialContent, null, tutorialAreaText)),
        React.createElement(VABArea, { rowSize: buttonRowSize },
            buttonRowSize === 8 && (React.createElement(FreeSpace, null,
                React.createElement(BackgroundImg, { src: TopLeft }),
                React.createElement("div", null),
                React.createElement(BackgroundImg, { src: BottomLeft }),
                React.createElement("div", null))),
            React.createElement(VAB, { rowSize: buttonRowSize }, (mainArray || []).map(function (row) {
                return row.map(function (arrayButton, index) {
                    var clickConfig = arrayButton.onClick;
                    var actionConfig = arrayButton['$action'];
                    var actionPayload = arrayButton['$actionPayload'];
                    return (React.createElement(TouchPanelButton, __assign({}, omit(arrayButton, [
                        'onClick',
                        '$action',
                        '$actionPayload',
                    ]), { bWidth: 84, bHeight: buttonHeight, id: arrayButton.id, key: "" + arrayButton.id + index, label: arrayButton.label, onTouchPanelButtonClick: function () {
                            return onButtonClick(arrayButton.id, clickConfig, actionConfig, actionPayload);
                        }, content: content.touchPanelVariables, onToggleButtonClick: onToggleButtonClick })));
                });
            })),
            buttonRowSize === 8 && (React.createElement(FreeSpace, null,
                React.createElement(BackgroundImg, { src: TopRight }),
                React.createElement("div", null),
                React.createElement(BackgroundImg, { src: BottomRight }),
                React.createElement("div", null)))),
        React.createElement(FAB, null, fabButtons.map(function (fabButton) {
            var clickConfig = fabButton.onClick;
            var actionConfig = fabButton['$action'];
            var actionPayload = fabButton['$actionPayload'];
            return (React.createElement(TouchPanelButton, __assign({}, omit(fabButton, ['onClick', '$action', '$actionPayload']), { id: fabButton.id, key: fabButton.id, label: fabButton.label, onTouchPanelButtonClick: function () {
                    return onButtonClick(fabButton.id, clickConfig, actionConfig, actionPayload);
                }, content: content.touchPanelVariables, onToggleButtonClick: onToggleButtonClick })));
        }))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=index.js.map